import ViewsSurveysView from '@/views/surveys/ViewsSurveysView.vue';
import ViewsSurveysDelivery from '@/views/surveys/ViewsSurveysDelivery.vue';

import {home} from '../breadcrumbs';
import {RouteRecordRaw} from 'vue-router';

export default [
    {
        path: '/surveys/delivery',
        name: 'surveys.delivery',
        component: ViewsSurveysDelivery,
        meta: {}
    },
    {
        path: '/surveys/:survey_id',
        name: 'surveys.view',
        component: ViewsSurveysView,
        meta: {
            requiresAuth: true,
            breadcrumbs: [home]
        }
    }
] as RouteRecordRaw[]
